<template>
  <div ref="loadingScreen" class="loading">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352.04 175.61">
      <g id="Calque_2" data-name="Calque 2">
        <g id="Calque_1-2" data-name="Calque 1">
          <path class="path" stroke="white" stroke-width="3"
                d="M.5,173.43c11.28-.3,20.41-.06,26.76.23,7.3.32,11.76.36,20.69.44,12.84.11,14.43-.2,16.14-1.55,3.62-2.86,3.63-10.46,3.65-25.66a3.26,3.26,0,0,0-.88-2.65c-1.54-1.17-4.69.58-6.19,1.43-8.18,4.65-18.22,16-16.93,17.26,1.84,1.78,24.26-18.8,25.22-17.7.29.34-2,2-3.87,5.75-3.05,6.27-1.75,12.29-.77,16.81.85,4,1.93,5.53,3.31,6.09a4.15,4.15,0,0,0,2.44.11c5.23-1.12,14.81-.74,24.22-.37,7.41.29,8.07,1.18,9.84,0,1.32-.86,2.71-2.5,3.76-18.25.57-8.49,0-5,.11-24.56a9.35,9.35,0,0,0-.22-2.65c-2.24-9.09-19.3-13.42-20.9-10.84-1.84,3,14.21,18.75,18.58,20.68a5.29,5.29,0,0,1,2.93,2.61,4.34,4.34,0,0,1,.17,2.37c-.49,2.78-.44,9-.34,21.57a12.38,12.38,0,0,0,.34,3c.11.46,1.45,5.74,5.3,7a7,7,0,0,0,2.33.22c5.67,0,11.35-.23,17-.11a4.52,4.52,0,0,0,2-.22c3-1.21,3.63-6.33,3.87-8.85,2.08-21.62.11-45.23.11-45.23-.77-9.3.34-4.22.11-8.63a4.09,4.09,0,0,1,.22-1.66c.66-1.76,2.45-2.31,3.54-3,3.53-2.19,4.3-8.61,2.88-12.94-.47-1.4-1.19-3.6-2.88-4.09-2.74-.79-6.86,3.29-8,7.63-1.17,4.58.89,9.92,2.76,10.07,1.37.1,2.52-2.56,2.66-2.88,1.43-3.3,0-7.09-1.88-9.4-.32-.38-3.49-4.23-6.2-3.43-3.11.92-4.27,7.57-3.42,12.5a25.48,25.48,0,0,0,7.85,14,10.69,10.69,0,0,1,3.16,3.79,10.83,10.83,0,0,1,.71,6.16c-2.16,15.69-.9,35.9-.77,37.6a10.32,10.32,0,0,0,.22,1.55c.08.39,1.36,6.35,5,7.3a5.64,5.64,0,0,0,2.1,0c2.54-.19,5.09-.07,7.64-.11,6.63-.1,8.21.36,14.48,0a17.58,17.58,0,0,0,2.33-.21c6.16-2,7-15,7.41-20.24.25-3.66,0-4.11-.22-12.83-.41-15.54.36-14.1-.11-24.77-.41-9.08-1-11.77,0-17.37A50.84,50.84,0,0,0,180,91.92a31.4,31.4,0,0,0-1.21-12.16c-.41-1.21-3.72-10.68-13.28-15-1.58-.73-7-3.12-13-1.44-1.53.42-4.37,1.21-4.75,3-.69,3.19,7.14,7.23,8.62,8a29,29,0,0,0,35.06-5.64c4.58-4.44,5-7.46,5.09-8.41.05-.57.4-4.93-2.43-7.19a6.53,6.53,0,0,0-4.54-1.33c-7.18.89-7.89,19.65-14.26,44-.41,1.54-1.35,5.1-.22,5.75,1.36.8,5.09-3.08,7-5.42a24,24,0,0,0,5.64-14.48c.05-2.36.06-4.53-1.32-6.75-1.67-2.68-5.18-5.13-8-4.42-4.61,1.16-7.71,11-5.08,18,1.57,4.2,4.56,5.65,5.53,11.06a18.65,18.65,0,0,1-.12,6.75c-1,5.94-.32,22.46,1,55.52,0,.1,0,.68.11,1.44.11,1,1.11,10.22,5.86,11.72a17.4,17.4,0,0,0,3.21.11c3.16,0,5.48-.2,5.75-.22,7.39-.61,25-2.06,32,0a2.73,2.73,0,0,0,1.88,0c2.63-1.14,2.11-7.7,2-9.4-1.29-19.22,2.77-38.47,2.65-57.73-.18-30.16-.28-45.24,5.86-55.08,0,0,8.21-13.16,31.08-23.67,7.6-3.49,10.08-1.85,10.73-1.33a4.91,4.91,0,0,1,1.55,2.77c1.34,5.31-3.75,12.48-9.74,14a8.4,8.4,0,0,1-5.42-.23c-.28-.12-3.18-1.38-3.2-3.09,0-1.4,1.88-2.69,5.64-4.21,10.54-4.27,18.82-3.59,29.86-4.31a17.61,17.61,0,0,1,3.76.22c2,.34,4.1.72,5.53,2.44A5.25,5.25,0,0,1,310,37.84c.12,1,0,2.92-3.21,6.08-2.26,2.26-6.22,6.2-12.72,7.19-2.69.41-6.55-.42-14.16-2.1-8.35-1.84-8.66-2.39-12.27-2.65C262.53,46,258,45.65,254,48.24c-2.41,1.54-2,2.42-8.51,8.62-2.87,2.73-3.79,3.36-4.87,3.87-3.68,1.77-7.27,1.32-9.62,1-2-.28-6-1.06-12.06-4.76-5.38-3.29-8.64-6.61-13.71-11.83a124.66,124.66,0,0,1-10.95-13A34.51,34.51,0,0,1,187.74,18a4.22,4.22,0,0,1,.34-3.32c1.9-2.6,8.58-1,12.49.89a18.4,18.4,0,0,1,8.52,8.07A21,21,0,0,1,211,30.76a38.5,38.5,0,0,1-.22,12c-1.15,8.13-3.23,9.64-3.87,10.06a3.59,3.59,0,0,1-2.21.77c-3.48-.21-5.86-7.47-6.42-12.38-.43-3.74-1-9.06,2.54-13.16,4.74-5.43,12.81-4.14,14.49-3.87,2.57.4,6.79,1.08,9.29,4.75,2.67,3.92,2.09,9.37-.44,12.94-.79,1.11-2.19,3.09-4.42,3.54-6.49,1.32-14.45-11.27-13.27-12.5,1-1.07,11.55,3.88,17.69,12.94.89,1.31,8.07,12.13,13.05,20.57.35.59,1.33,2.26,2.21,2.11s1.26-2.17,1.44-3.32c1.4-8.91.89-13,.89-13-1-8.38-1.72-13.87-4.87-21.13,0,0-8.35-19.23-25.11-26.21-1.68-.7-2.21-.56-2.43-.33-1.13,1.15,1.94,8,7.52,11.28a16.77,16.77,0,0,0,17.48-.66c1-.69,5-3.65,5.75-8.41a5.6,5.6,0,0,0-.67-4.31C238,.52,235.18.16,233.2.79c-3.7,1.19-5.21,6.15-5.42,9.4-.26,4,1.4,5.35,4,12a78,78,0,0,1,4.49,16.84,69.62,69.62,0,0,1,.88,13.38,61.26,61.26,0,0,1-1.53,11.38c-3.4,15.41-3,42-2.23,85.39,0,0,0,1,.11,2.88.54,10.57,1,18.95,5.64,21.9a8.32,8.32,0,0,0,4.65,1.1c32.22,0,107.72,0,107.72,0"/>
        </g>
      </g>
    </svg>

    <p class="u-uppercase loading__text">Chargement ...</p>

    <div class="headphones">
      <img src="/images/loader/headphone.svg" alt="icon for sound, headphone">
      <p>L'expérience nécessite l'activation du son.</p>
    </div>
  </div>
</template>

<script lang="js">
import WebGl from '@/webgl/webglManager'

export default {
  name: 'Loading',
  props: {
    isHome: {
      required: false,
      default: false
    }
  },
  mounted() {
    const manager = new WebGl()
    manager.getLoaderRef(this.$refs.loadingScreen)
  }
}
</script>

<style scoped lang="scss">
.loading {
  height: 100vh;
  width: 100vw;
  background: black;
  position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  flex-direction: column;
  opacity: 1;
  visibility: visible;
  z-index: 10000;

  svg {
    height: 165px;
    width: 13vw;

    .path {
      stroke-dasharray: 2300;
      stroke-dashoffset: 2300;
      animation: dash 3.5s linear infinite;
    }
  }

  @keyframes dash {
    from {
      stroke-dashoffset: 2300;
    }
    to {
      stroke-dashoffset: 0;
    }
  }

  .headphones {
    position: absolute;
    bottom: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    img {
      margin-bottom: 16px;
    }
  }

  &__text {
    font-family: 'RoadRage', sans-serif;
    font-size: 24px;
    color: $white;
  }
}

.loaded {
  opacity: 0;
  visibility: hidden;
}

</style>